<template>
    <div>
        <section class="content-header">
            <div>
                <h1>
                    {{title}}
                    <small>{{subTitle}}</small>
                </h1>
            </div>
            <div>
                <slot name="right-align"></slot>
            </div>
        </section>

        <!-- Main content -->
        <section class="content container-fluid">

            <slot></slot>

        </section>
    </div>
</template>

<script>
    export default {
        name: 'HelloWorld',
        props: {
            title: String,
            subTitle: String
        }
    }
</script>
